var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInternetBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M210,198.7H12v6c0,9.9,1.8,18,11.6,18H210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M264,120.7v-72c0-9.9-14.4-18-24.4-18h-192c-9.9,0-11.6,8.1-11.6,18v150h174"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 210,174.7 60,174.7 60,54.7 240,54.7 240,120.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M288,261.4c0,5.2-4.2,9.4-9.4,9.4h-53.2c-5.2,0-9.4-4.2-9.4-9.4V136.1c0-5.2,4.2-9.4,9.4-9.4h53.2c5.2,0,9.4,4.2,9.4,9.4V261.4z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 222,
    y1: 150.7,
    x2: 282,
    y2: 150.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 222,
    y1: 246.7,
    x2: 282,
    y2: 246.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInternetBanking);
export default __webpack_public_path__ + "static/media/Icon_Internet_Banking.9dca1baa3530ac1ea6a7d02b9618f6a1.svg";
export { ForwardRef as ReactComponent };